import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { getHomepageNews, mediaUrl } from "@/lib/api";
import { SectionHeading } from "@/components/site/SectionHeading";
import { Reveal } from "@/components/site/Reveal";

const HomeNewsItem = ({ item }) => {
  const cover = item.coverMediaId ? mediaUrl(item.coverMediaId) : (item.coverUrl || null);
  const date = item.publishedAt
    ? new Date(item.publishedAt).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })
    : "";
  const meta = [date, item.category].filter(Boolean).join("  \u00b7  ");
  return (
    <Link to={`/news/${item.slug}`} data-testid="home-news-item" className="group flex flex-col">
      <div className="overflow-hidden rounded-[10px]" style={{ background: "var(--bg-elev-1)", border: "1px solid var(--card-border)", aspectRatio: "16 / 10" }}>
        {cover ? (
          <img src={cover} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
        ) : (
          <div className="flex h-full w-full items-center justify-center"><span className="motif-caps">{item.category || "News"}</span></div>
        )}
      </div>
      {meta && <p className="mt-4 text-[11px] uppercase" style={{ color: "var(--fg-subtle)", letterSpacing: "0.18em" }}>{meta}</p>}
      <h3 className="mt-2 text-[17px] leading-snug" style={{ color: "var(--text)", fontWeight: 500, letterSpacing: "0.2px" }}>{item.title}</h3>
      {item.excerpt && <p className="mt-2 text-[13.5px] leading-[1.75]" style={{ color: "var(--muted)" }}>{item.excerpt}</p>}
    </Link>
  );
};

export const HomeNews = () => {
  const { data } = useQuery({ queryKey: ["homepage-news"], queryFn: getHomepageNews });
  if (!data || !data.enabled) return null;
  const items = (data.items || []).slice(0, 3);
  if (items.length === 0) return null;

  return (
    <div className="surface-cream">
      <section className="container-inst py-20 lg:py-28" data-testid="home-news-section">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHeading title="News" description="Announcements and stories from across Acharya Holdings and its ventures." />
          <Link to="/news" data-testid="home-view-all-news" className="btn btn-secondary btn-sm">
            View All News <ArrowRight size={14} />
          </Link>
        </div>
        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((n, i) => (
            <Reveal key={n.id} delay={i * 0.05}><HomeNewsItem item={n} /></Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};
